import { register } from 'tmr/tmr/ngModuleRegistry'

import * as alertLevels from './alertLevels'
import * as alertTargets from './alertTargets'
import * as antennaMemoryBanks from './antennaMemoryBanks'
import * as antennaReadOperations from './antennaReadOperations'
import * as antennaWriteOperations from './antennaWriteOperations'
import * as antennaKillOperations from './antennaKillOperations'
import * as apiPrefix from './apiPrefix'
import * as apiAuthToken from './apiAuthToken'
import * as appName from './appName'
import * as barcodeReaderTypes from './barcodeReaderTypes'
import * as checklistTypes from './checklistTypes'
import * as conveyorTypes from './conveyorTypes'
import * as conveyorModeTypes from './conveyorModeTypes'
import * as dateFormats from './dateFormats'
import * as defaultApiEndpoints from './defaultApiEndpoints'
import * as defaultAppState from './defaultAppState'
import * as defaultExportFormat from './defaultExportFormat'
import * as defaultOperationsConfig from './defaultOperationsConfig'
import * as defaultPagingParams from './defaultPagingParams'
import * as deviceControllerTypes from './deviceControllerTypes'
import * as encodingEpcReadModes from './encodingEpcReadModes'
import * as env from './env'
import * as eventLogLevelTypes from './eventLogLevelTypes'
import * as frontendCapabilities from './frontendCapabilities'
import * as identifierTypes from './identifierTypes'
import * as languages from './languages'
import * as operationConfigurationTypes from './operationConfigurationTypes'
import * as movementTypes from './movementTypes'
import * as placeTypes from './placeTypes'
import * as printerTypes from './printerTypes'
import * as productionWorkflowOperations from './productionWorkflowOperations'
import * as resourcePollingInterval from './resourcePollingInterval'
import * as rfidReaderConnectionModes from './rfidReaderConnectionModes'
import * as rfidReaderEmulatorModes from './rfidReaderEmulatorModes'
import * as rfidReaderImpinjReaderModes from './rfidReaderImpinjReaderModes'
import * as rfidReaderImpinjSearchModes from './rfidReaderImpinjSearchModes'
import * as rfidReaderStartStopTypes from './rfidReaderStartStopTypes'
import * as rfidReaderTypes from './rfidReaderTypes'
import * as shippingNoticeStates from './shippingNoticeStates'
import * as shippingParcelStates from './shippingParcelStates'
import * as tagTypes from './tagTypes'
import * as transferTypes from './transferTypes'
import * as userDateFormats from './userDateFormats'
import * as xspanFieldOfView from './xspanFieldOfView'
import * as xspanMode from './xspanMode'
import * as zoneTypes from './zoneTypes'
import * as checklistOperationTypes from './checklistOperationTypes'
import * as limitZeroWorkaround from './limitZeroWorkaround'

export default register(
  'tmr.core.constants',
  alertLevels,
  alertTargets,
  antennaMemoryBanks,
  antennaReadOperations,
  antennaWriteOperations,
  antennaKillOperations,
  apiPrefix,
  apiAuthToken,
  appName,
  barcodeReaderTypes,
  checklistTypes,
  conveyorModeTypes,
  conveyorTypes,
  dateFormats,
  defaultApiEndpoints,
  defaultAppState,
  defaultExportFormat,
  defaultOperationsConfig,
  defaultPagingParams,
  deviceControllerTypes,
  encodingEpcReadModes,
  env,
  eventLogLevelTypes,
  frontendCapabilities,
  identifierTypes,
  languages,
  operationConfigurationTypes,
  movementTypes,
  performance,
  placeTypes,
  printerTypes,
  productionWorkflowOperations,
  resourcePollingInterval,
  rfidReaderConnectionModes,
  rfidReaderEmulatorModes,
  rfidReaderImpinjSearchModes,
  rfidReaderImpinjReaderModes,
  rfidReaderStartStopTypes,
  rfidReaderTypes,
  shippingNoticeStates,
  shippingParcelStates,
  tagTypes,
  transferTypes,
  userDateFormats,
  xspanFieldOfView,
  xspanMode,
  zoneTypes,
  checklistOperationTypes,
  limitZeroWorkaround
)
